// CompanyAssessmentStatus.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./assessmentstatus.module.css";
import { useNavigate } from "react-router-dom";

/* ───── helpers ───── */
const fetchStatusByCompany = async (admincode) => {
  const res = await axios.post(
    "https://casaahaanahotels.com/assessment_status_by_company",
    { admincode },
    { headers: { "Content-Type": "application/json" } }
  );
  return Array.isArray(res.data) ? res.data : [];
};

/* ───── component ───── */
const CompanyAssessmentStatus = () => {
  const [companyName, setCompanyName] = useState("");
  const [admincode, setAdmincode] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const navigate = useNavigate();

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  /* grab company info from localStorage & load */
  useEffect(() => {
    const userDataStr = localStorage.getItem("user_data");
    let code = "";
    if (userDataStr) {
      try {
        const u = JSON.parse(userDataStr);
        code = u.admincode || "";
        setCompanyName(u.companyname || "");
      } catch (e) {
        console.error("Error parsing user_data", e);
      }
    }
    setAdmincode(code);
    if (code) handleSearch(code);
    else setMsg("Admin code not found in localStorage");
  }, []);

  /* load table for this company */
  const handleSearch = async (code = admincode) => {
    if (!code) {
      setMsg("Admin code not selected.");
      setRows([]);
      return;
    }
    setMsg("");
    setLoading(true);
    try {
      const data = await fetchStatusByCompany(code);
      if (data.length === 0) setMsg("No assessments found.");
      setRows(data);
      setCurrentPage(1); // Reset to first page
    } catch (e) {
      console.error(e);
      setMsg("Failed to fetch assessment status.");
    } finally {
      setLoading(false);
    }
  };

  // Pagination logic
  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const completedRows = rows.filter(row => row.status === "Completed");
const paginatedRows = completedRows.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);

  console.log('paginated row = ', paginatedRows)

  // Helper to generate pagination numbers with ellipsis
  const getPagination = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
      }
    }
    return pages;
  };

  const handlePageClick = (page) => {
    if (page === "...") return;
    setCurrentPage(page);
  };

  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  /* progress cell */
  const Progress = ({ pct }) => {
    const num = parseInt(pct, 10) || 0;
    return (
      <div className={styles.progressWrapper}>
        <span className={styles.progressText}>{pct}</span>
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{
              width: pct,
              backgroundColor: num === 100 ? "#2ecc71" : "#003366",
            }}
          />
        </div>
      </div>
    );
  };

  /* status badge */
  const Badge = ({ progress }) => (
    <span
      className={`${styles.statusBadge} ${
        progress === "100%" ? styles.statusComplete : styles.statusIncomplete
      }`}
    >
      {progress === "100%" ? "Completed" : "In Progress"}
    </span>
  );

  // const handleCertificate = (driverId) => {
  //   navigate(`/assessment/certificate/${driverId}`);
  // };

   const handleCertificate = (selectedCode, assId) => {
    const url = `/certificate/${selectedCode}/${assId}`;
    window.open(url, "_blank");
  };


  /* ───── render ───── */
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{companyName || "Assessment Status"}</h2>
      <button onClick={() => handleSearch()} className={styles.refreshButton}>
        Refresh
      </button>

      {loading ? (
        <p className={styles.loadingText}>Loading…</p>
      ) : msg ? (
        <p className={styles.errorText}>{msg}</p>
      ) : (
        <div className={styles.tableWrapper}>
          <table className={styles.assessmentTable}>
            <thead>
              <tr>
                <th>Driver Name</th>
                <th>Company Name</th>
                <th>Department</th>
                <th style={{ textAlign: "center" }}>Progress</th>
                <th>Status</th>
                <th>View Certificate</th>
              </tr>
            </thead>
            <tbody>
              {paginatedRows.map((r, i) => (
                <tr key={i}>
                  <td>{r.driver_name || "Unknown"}</td>
                  <td>{r.company_name}</td>
                  <td>{r.assessment_type}</td>
                  <td style={{ textAlign: "center" }}>
                    <Progress pct={r.progress} />
                  </td>
                  <td>
                    <Badge progress={r.progress} />
                  </td>
                  <td style={{ textAlign: "center" }}>
                      {r.status === "Completed" && r.score > 2 ? (
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "white",
                          width: "50%",
                          textAlign: "center",
                          background: "#88E788",
                          borderRadius: "4px",
                          cursor: "pointer",
                          width: "100%"
                        }}
                        onClick={() =>
                          handleCertificate( admincode, r.assessment_id)
                        }
                      >
                        View
                      </p>
                    ) : r.score <= 2 ? (
                      <p
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "white",
                          background: "#FF7074",
                          padding: "1px 2px",
                          borderRadius: "4px",
                          cursor: "default",
                        }}
                      >
                        Fail
                      </p>
                    ) : (
                      <p
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "white",
                          background: "#FF7074",
                          padding: "3px 5px",
                          borderRadius: "4px",
                          cursor: "default",
                        }}
                      >
                        Pending
                      </p>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className={styles.pagination} style={{ marginTop: '16px', display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center' }}>
              <button className={styles.pageButton} onClick={handlePrev} disabled={currentPage === 1}>
                Prev
              </button>
              {getPagination().map((page, idx) =>
                page === "..." ? (
                  <button key={idx} disabled className={styles.ellipsisButton}>
                    ...
                  </button>
                ) : (
                  <button
                    key={idx}
                    onClick={() => handlePageClick(page)}
                    className={
                      page === currentPage ? styles.activePageButton : styles.pageButton
                    }
                    style={{
                      color: `${page === currentPage ? "white" : "#444"}`,
                      padding: "6px 10px",
                      background: `${page === currentPage ? "#002060" : "#f0f4fa"}`,
                      borderRadius: "4px",
                      margin: "0 4px",
                      border: `${page === currentPage ? "2px solid #002060" : " 2px solid #e5e5e5ff"}`,
                    }}
                  >
                    {page}
                  </button>
                )
              )}
              <button onClick={handleNext} disabled={currentPage === totalPages} className={styles.pageButton}>
                Next
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CompanyAssessmentStatus;
